import React, { useEffect, useState } from 'react'
import { useList } from 'react-firebase-hooks/database'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import LoadIcon from '../../components/LoadIcon'
import SideAgenda from '../../components/SideAgenda.js'
import config from '../../config'
import { muteMusic, showGlobalModal, unmuteMusic } from '../../ducks/layout'
import { RoomDb } from '../../firebaseConfig'
import closeTheatre from '../../images/mobile/close-theatre.png'
import openTheatre from '../../images/mobile/open-theatre.png'
import screen from '../../images/mobile/screen.png'
import routes from '../../routes'
import { COLORS } from '../../styles/theme'
import Amplitude from '../../utils/amplitudeHelper'

const MobileAuditorium = ({ currentUser, liveUrl, hallNumber }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(true)
  const [sidebar, setSidebar] = useState(false)
  const [theatre, setTheatre] = useState(false)
  const [videoUrl, setVideoUrl] = useState()
  const [snapshots] = useList(RoomDb)
  const [status, setStatus] = useState(false)
  const [recording, setRecording] = useState(false)

  useEffect(() => {
    if (hallNumber == 1) {
      if (snapshots.length) {
        let hall = snapshots.filter((item) => {
          if (item.val().hallNumber === hallNumber) {
            return item
          }
        })
        setStatus(hall[0].val().active)
        if (!hall[0].val().active) {
          if (currentUser.role !== 'superadmin') {
            history.push(routes.lobby)
            toast('The Auditorium Hall will reopen tomorrow at 8am.')
          }
        }
      }
    }
  }, [snapshots])

  useEffect(() => {
    document.title = `${config.eventName} | Conference`
    Amplitude.visit(`Auditorium ${hallNumber} `)
  }, [currentUser.id, hallNumber])

  useEffect(() => {
    dispatch(muteMusic())

    return () => {
      if (localStorage.getItem('muted') === 'false') {
        dispatch(unmuteMusic())
      }
    }
  }, [dispatch])

  const displayAgenda = () => {
    Amplitude.clickAgenda()
    dispatch(showGlobalModal('agenda'))
  }

  const toggleSidebar = () => {
    if (sidebar === false) {
      Amplitude.clickProgrammeButton()
    }
    setSidebar(!sidebar)
  }
  const handlePlayback = (session) => {
    if (session.vimeo_id !== '') {
      Amplitude.watchRecording(session.id)
      setVideoUrl(`https://player.vimeo.com/video/${session.vimeo_id}`)
      setSidebar(false)
      setIsLoading(false)
    } else if (session.redirect_url) {
      console.log(session.redirect_url)
    }
  }

  const handleRecording = () => {
    Amplitude.watchPlayback()
    setVideoUrl(true)
    setRecording(true)
  }

  const handleLive = () => {
    setVideoUrl(undefined)
    setRecording(false)
  }

  const displaySpeakers = () => {
    Amplitude.clickSpeaker()
    dispatch(showGlobalModal('speaker'))
  }

  const videoContainerTheatreStyle = {
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: 'black',
    zIndex: '99',
  }

  return (
    <Page>
      <SideAgenda handlePlayback={handlePlayback} open={sidebar} toggleSidebar={toggleSidebar} hallNumber={hallNumber} currentUser={currentUser} />
      <div className="outer-wrapper">
        <div className="container">
          <div className="programme-wrap">
            {hallNumber === 5 ? (
              <button type="button" className="action-button" onClick={toggleSidebar}>
                <small style={{ whiteSpace: 'nowrap' }}>KNOWLEDGE SHARING</small>
              </button>
            ) : hallNumber === 1 ? (
              recording ? (
                <button type="button" className="action-button-live" onClick={handleLive}>
                  <small>WATCH LIVE STREAM</small>
                </button>
              ) : (
                <button type="button" className="action-button" onClick={handleRecording}>
                  <small>DAY 1 RECORDING</small>
                </button>
              )
            ) : (
              <button type="button" className="action-button" onClick={toggleSidebar}>
                <small>PAPER PRESENTERS</small>
              </button>
            )}
            <button className="action-button programme-btn" onClick={displayAgenda}>
              <small>PROGRAMME</small>
            </button>
            <button type="button" className="action-button faculty-btn" onClick={displaySpeakers}>
              <small>SPEAKERS</small>
            </button>
          </div>
          <div className="screen-container">
            <img src={screen} className="screen" alt="screen" />
            <div className="video-container" style={theatre ? videoContainerTheatreStyle : {}}>
              {isLoading && <LoadIcon />}
              <iframe
                title="Live Broadcast"
                src={
                  hallNumber == 1 && videoUrl == undefined
                    ? `${liveUrl}?autoplay=1`
                    : hallNumber == 1 && videoUrl == true
                    ? 'https://player.vimeo.com/video/598881061?h=5b9fab1594&autoplay=1'
                    : videoUrl
                    ? `${videoUrl}?autoplay=1`
                    : `https://player.vimeo.com/video/608131148?h=9ff1d27a73&autoplay=1&loop=1`
                }
                allow="autoplay; fullscreen"
                allowFullScreen
                frameBorder="0"
                onLoad={() => {
                  setIsLoading(false)
                }}
              />
            </div>
          </div>

          <button type="button" className="theatre-button" onClick={() => setTheatre(true)}>
            <img src={openTheatre} className="theatre-button-icon" alt="theatre-icon" />
            <p className="theatre-button-label">Theatre mode</p>
          </button>
        </div>

        <div className="chat-container">
          <iframe src="https://app.sli.do/event/opytiuns" height="100%" width="100%" frameBorder="0" style={{ minHeight: '560px' }} title="Slido" />
        </div>

        {theatre && (
          <div className="theatre-close">
            <img src={closeTheatre} onClick={() => setTheatre(false)} className="theatre-close-icon" alt="close-icon" />
          </div>
        )}
      </div>
    </Page>
  )
}

const Page = styled.div`
  background: url(${config.assets.auditorium1.portrait});
  background-size: cover;
  background-position: 50% 50%;
  height: calc(100% - 60px);
  width: 100vw;
  overflow-y: scroll;

  position: absolute;

  .outer-wrapper {
    width: 100%;
  }

  .container {
    width: 95%;
    margin: auto;
  }

  .programme-wrap {
    display: flex;
    margin-top: 15px;
    justify-content: space-between;
  }

  .button-container {
    width: 100%;
    display: grid;
    grid-gap: 12px;
    margin: 15px 0;
  }
  .action-button {
    width: 100%;
    background: linear-gradient(#ff9821, #f83636);
    border-radius: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${COLORS.hotButtonText};
    border: 2px solid ${COLORS.hotButtonText};
    padding: 10px;
    font-size: 12px;
    margin-bottom: 10px;
    small {
      font-weight: 500;
    }
  }

  .action-button-live {
    width: 100%;
    background: linear-gradient(270deg, #fe1e9a, #254dde);
    border-radius: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${COLORS.hotButtonText};
    border: 2px solid ${COLORS.hotButtonText};
    padding: 10px;
    font-size: 12px;
    margin-bottom: 10px;
    small {
      font-weight: 500;
    }
  }

  /* .programme-btn {
    margin-right: 10px;
  }

  .faculty-btn {
    margin-left: 10px;
  } */
  .checkin-icon {
    background: ${COLORS.hotButtonBg};
    border-radius: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${COLORS.hotButtonText};
    border: 2px solid ${COLORS.hotButtonText};
    padding: 12px 16px;
    width: 125px;
    small {
      font-weight: 500;
    }
  }
  .checkin-container {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 30px 0px 20px 0px;
  }

  .checkin {
    width: 38%;
    height: auto;
  }

  .screen-container {
    width: 100%;
    height: 0;
    padding-bottom: 58.5%;
    position: relative;
  }

  .screen {
    width: 100%;
    position: absolute;
  }

  .video-container {
    width: 92%;
    height: 81%;
    background: #1e1e1e;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50.5%, -51%);

    iframe {
      height: 100%;
      width: 100%;
    }
  }

  .title {
    width: 100%;
    margin: 20px 0px;
  }

  .chat-container {
    width: 100%;
    height: 500px;
    margin-top: 36px;
  }

  .theatre-button {
    width: 140px;
    height: 30px;
    background: black;
    margin: 10px 10px 0px 0px;
    float: right;
    border: none;
    border-radius: 5px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    opacity: 0.6;
    padding: 0;
  }

  .theatre-button-label {
    color: white;
    font-size: 12px;
    margin: 0px 10px 0px 0px;
  }

  .theatre-button-icon {
    width: 20px;
    margin: 0px 10px;
  }

  .theatre-close {
    color: white;
    background: black;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 99;
    opacity: 0.6;
  }

  .theatre-close-icon {
    width: 20px;
  }

  @media screen and (min-width: 540px) {
    .outer-wrapper {
      /* width: 540px; */
      margin: auto;
    }
  }
`

export default MobileAuditorium
